module.exports = __webpack_public_path__ + "static/img/IMG_20241030_170351.7ba68058.jpg";